import { render, staticRenderFns } from "./picketageRelationWarning.vue?vue&type=template&id=2f1c4d42&scoped=true"
import script from "./picketageRelationWarning.vue?vue&type=script&lang=js"
export * from "./picketageRelationWarning.vue?vue&type=script&lang=js"
import style0 from "./picketageRelationWarning.vue?vue&type=style&index=0&id=2f1c4d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c4d42",
  null
  
)

export default component.exports